import { render, staticRenderFns } from "./ModalOverlay.vue?vue&type=template&id=a0a5ba46&scoped=true&lang=pug&"
import script from "./ModalOverlay.vue?vue&type=script&lang=js&"
export * from "./ModalOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ModalOverlay.vue?vue&type=style&index=0&id=a0a5ba46&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a5ba46",
  null
  
)

export default component.exports